export default __webpack_public_path__ + "static/media/home1-banner5.a9846126.jpg";